var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "v-select",
    _vm._g(
      _vm._b(
        {
          ref: "select",
          staticClass: "studip-v-select",
          attrs: {
            "calculate-position": _vm.withPopper,
            "append-to-body": "",
          },
          on: {
            change: _vm.updateValue,
          },
          scopedSlots: _vm._u(
            [
              _vm._l(_vm.$scopedSlots, function (index, name) {
                return {
                  key: name,
                  fn: function fn(data) {
                    return [_vm._t(name, null, null, data)]
                  },
                }
              }),
            ],
            null,
            true
          ),
        },
        "v-select",
        Object.assign({}, _vm.$props, _vm.$attrs),
        false
      ),
      _vm.$listeners
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }